import { getPlayerValue, getPlayerWeeklyWage } from '../domain/constants';
import { GameState, Player, Personality, Position, TeamInLeague, GameConfig } from '../domain/entities';

const MALE_PLAYER_FACES = ['👨', '👨🏻', '👨🏼', '👨🏽', '👨🏾', '👨🏿'];
const FEMALE_PLAYER_FACES = ['👩', '👩🏻', '👩🏼', '👩🏽', '👩🏾', '👩🏿'];

export const maleFirstNames = [
    'Aaron', 'Adam', 'Adrian', 'Ahmed', 'Alejandro', 'Alessandro', 'Alex', 'Anders', 'Andrea', 'Antoine', 'Antonio', 'Barry', 'Bastian', 'Ben', 'Benjamin', 'Billy', 'Bjorn', 'Bram', 'Brian', 'Bruno', 'Callum', 'Carlos', 'Charlie', 'Chris', 'Christian', 'Christophe', 'Craig', 'Daan', 'Damian', 'Dan', 'Daniele', 'David', 'Davide', 'Dean', 'Dennis', 'Didier', 'Diego', 'Dominic', 'Eden', 'Elliot', 'Emmanuel', 'Enzo', 'Erik', 'Ethan', 'Etienne', 'Fabio', 'Felix', 'Filip', 'Filippo', 'Florian', 'Florent', 'Francesco', 'Frank', 'Fred', 'Gabriel', 'Gary', 'George', 'Giacomo', 'Giovanni', 'Gregor', 'Grzegorz', 'Guillaume', 'Gustaf', 'Habib', 'Hans', 'Harry', 'Henrik', 'Henry', 'Heung-min', 'Hugo', 'Ian', 'Ibrahim', 'Ivan', 'Jack', 'James', 'Jan', 'Javier', 'Jean', 'Joao', 'Joe', 'John', 'Jordan', 'Joris', 'Josh', 'Jurgen', 'Kaoru', 'Kasper', 'Kevin', 'Klaus', 'Kyle', 'Lars', 'Laurent', 'Lee', 'Leo', 'Liam', 'Luca', 'Lukas', 'Luke', 'Luis', 'Luka', 'Magnus', 'Manuel', 'Marc', 'Marco', 'Marek', 'Mark', 'Markus', 'Matt', 'Mateo', 'Mateusz', 'Mathieu', 'Matteo', 'Max', 'Michael', 'Milan', 'Mohamed', 'Morten', 'Nathan', 'Neil', 'Nico', 'Nicolas', 'Nick', 'Oliver', 'Olivier', 'Oscar', 'Owen', 'Pablo', 'Paolo', 'Patrick', 'Paul', 'Pedro', 'Peter', 'Phil', 'Philipp', 'Pieter', 'Piotr', 'Quentin', 'Rafael', 'Rasmus', 'Reece', 'Remi', 'Rhys', 'Ricardo', 'Richard', 'Rob', 'Robert', 'Roberto', 'Ryan', 'Sadio', 'Sam', 'Samuel', 'Sander', 'Scott', 'Sean', 'Sebastien', 'Sergio', 'Shinji', 'Simon', 'Simone', 'Soren', 'Stefan', 'Stefano', 'Stephen', 'Steve', 'Takehiro', 'Thierry', 'Thijs', 'Thiago', 'Thomas', 'Tim', 'Tomas', 'Tom', 'Tony', 'Uwe', 'Victor', 'Vincent', 'Vladimir', 'Wayne', 'Wesley', 'Will', 'Wolfgang', 'Wout', 'Yannick', 'Yuto', 'Zinedine'
];
export const femaleFirstNames = [
    'Ada', 'Aitana', 'Alex', 'Alexandra', 'Alexia', 'Asisat', 'Barbra', 'Beth', 'Caitlin', 'Caroline', 'Christine', 'Debinha', 'Dzsenifer', 'Ellie', 'Ewa', 'Frida', 'Fridolina', 'Georgia', 'Guro', 'Hayley', 'Kadidiatou', 'Keira', 'Khadija', 'Lena', 'Lina', 'Linda', 'Lucy', 'Marta', 'Mary', 'Megan', 'Nadine', 'Pernille', 'Rebecka', 'Rose', 'Salma', 'Sam', 'Sophia', 'Stina', 'Tabitha', 'Vivianne', 'Wendie'
];
export const lastNames = [
    'Adebayor', 'Ali', 'Allen', 'Alvarez', 'Andersen', 'Aubameyang', 'Bailey', 'Baker', 'Bakker', 'Bauer', 'Becker', 'Bell', 'Bennett', 'Bernard', 'Bianchi', 'Błaszczykowski', 'Brown', 'Bruno', 'Campbell', 'Camara', 'Carter', 'Chen', 'Clark', 'Clarke', 'Colombo', 'Conti', 'Cook', 'Cooper', 'Costa', 'Coulibaly', 'Cox', 'Davies', 'Davis', 'De Bruyne', 'De Jong', 'De Luca', 'De Vries', 'Diallo', 'Diarra', 'Diaz', 'Drogba', 'Dubois', 'Durand', 'Dzeko', 'Edwards', 'Esposito', 'Essien', 'Evans', 'Fernandez', 'Ferrari', 'Fischer', 'Gallo', 'Garcia', 'Gonzalez', 'Graham', 'Gray', 'Greco', 'Green', 'Gueye', 'Hall', 'Hansen', 'Harris', 'Harrison', 'Hazard', 'Hill', 'Hoffmann', 'Honda', 'Horvat', 'Hughes', 'Ivanovic', 'Jackson', 'James', 'Jansen', 'Janssen', 'Jensen', 'Johansson', 'Johnson', 'Jones', 'Kagawa', 'Keita', 'Kelly', 'Khan', 'Kim', 'King', 'Koch', 'Kovac', 'Kristensen', 'Larsen', 'Laurent', 'Lee', 'Lefebvre', 'Leroy', 'Lewandowski', 'Lewis', 'Liu', 'Lopez', 'Lukaku', 'Mane', 'Marino', 'Martin', 'Martinez', 'Martins', 'Meijer', 'Meyer', 'Miller', 'Mitchell', 'Modric', 'Moore', 'Moreau', 'Morgan', 'Morris', 'Muller', 'Murphy', 'Nakata', 'Nilsson', 'Novak', 'Olsen', 'Park', 'Parker', 'Pedersen', 'Pereira', 'Perez', 'Petit', 'Phillips', 'Piszczek', 'Price', 'Rakitic', 'Richard', 'Richardson', 'Richter', 'Robert', 'Roberts', 'Robinson', 'Rodriguez', 'Romano', 'Romero', 'Rossi', 'Roux', 'Russo', 'Salah', 'Sanchez', 'Schafer', 'Schmidt', 'Schneider', 'Schulz', 'Scott', 'Silva', 'Simon', 'Singh', 'Smit', 'Smith', 'Son', 'Stewart', 'Svensson', 'Taylor', 'Thomas', 'Thompson', 'Tomiyasu', 'Torres', 'Toure', 'Traore', 'Turner', 'Van den Berg', 'Van Dijk', 'Vargas', 'Vertonghen', 'Visser', 'Wagner', 'Walker', 'Wang', 'Ward', 'Watson', 'Weber', 'White', 'Williams', 'Wilson', 'Wood', 'Wright', 'Yoshida', 'Young'
];

let playerIdCounter = 0;
let youthPlayerIdCounter = -1000;

export class PlayerGenerator {
    static resetPlayerIdCounter() {
        playerIdCounter = 0;
    }

    static getNextPlayerId(): number {
        return playerIdCounter++;
    }

    static initializePlayerIdCounter(state: GameState) {
        if (!state.gameStarted) return;
        const allPlayers = Object.values(state.leagues).flatMap(l => l.teams).flatMap(t => t.squad);
        const allYouth = Object.values(state.leagues).flatMap(l => l.teams).flatMap(t => t.youthAcademy.squad);
        const allPlayerIds = [...allPlayers, ...allYouth].map(p => p.id);
        // Ensure we only consider non-negative IDs, as youth players have negative IDs.
        const maxId = allPlayerIds.length > 0 ? Math.max(-1, ...allPlayerIds.filter(id => id >= 0)) : -1;
        playerIdCounter = maxId + 1;
        console.log(`Player ID counter initialized to ${playerIdCounter}`);
    }

    private static generateFlexibility(pos: 'GK'|'DEF'|'MID'|'FWD'): { categoryFlexibility: number; footFlexibility: number } {
        // Base flexibility by position
        const baseFlexibility: Record<string, { category: number; foot: number; }> = {
            'GK': { category: 50, foot: 60 },        // GK has some good feet
            'DEF': { category: 60, foot: 65 },       // Defenders reasonably adaptable
            'MID': { category: 75, foot: 75 },       // Midfielders very flexible
            'FWD': { category: 65, foot: 70 },       // Forwards moderately flexible
        };

        const base = baseFlexibility[pos];
        // Add variance: 15-point range around base
        const variance = (Math.random() - 0.5) * 30;

        return {
            categoryFlexibility: Math.max(40, Math.min(100, base.category + variance)),
            footFlexibility: Math.max(40, Math.min(100, base.foot + variance)),
        };
    }

    static generatePlayer(name: string, pos: 'GK'|'DEF'|'MID'|'FWD', skill: number, gender: 'male' | 'female', leagueName: string, config: GameConfig): Player {
        const personalityTypes: Personality[] = ['Ambitious', 'Loyal', 'Professional', 'Hot-headed'];
        const contractYears = 2 + Math.floor(Math.random() * 4); // 2-5 year contract
        const gameType = gender === 'female' ? 'womens' : 'mens';
        const wage = getPlayerWeeklyWage({ skill, gender } as Player, leagueName, gameType, config);
        const initialValue = getPlayerValue({ skill, gender, isPromotedYouth: false, gamesPlayed: 0, wage } as Player, leagueName, gameType, config);
        const fitnessMax = 80 + Math.floor(Math.random() * 21); // 80-100
        const fitnessRecovery = 8 + Math.floor(Math.random() * 9); // 8-16
        
        // FIX: Add favoredFoot and favoredPositionCategory properties
        const randFoot = Math.random();
        let favoredFoot: 'Left' | 'Right' | 'Either';
        if (randFoot < 0.65) favoredFoot = 'Right';
        else if (randFoot < 0.9) favoredFoot = 'Left';
        else favoredFoot = 'Either';

        let favoredPositionCategory: 'Central' | 'Wide' | 'Any';
        switch (pos) {
            case 'GK': favoredPositionCategory = 'Central'; break;
            case 'DEF': favoredPositionCategory = Math.random() < 0.5 ? 'Central' : 'Wide'; break;
            case 'MID': favoredPositionCategory = Math.random() < 0.5 ? 'Central' : 'Wide'; break;
            case 'FWD': favoredPositionCategory = Math.random() < 0.6 ? 'Central' : 'Wide'; break;
            default: favoredPositionCategory = 'Any';
        }

        return {
            id: this.getNextPlayerId(),
            name,
            age: 17 + Math.floor(Math.random() * 18), // Generate age between 17 and 34
            position: pos,
            skill,
            potential: skill + Math.floor(Math.random() * 15),
            form: 0,
            fitness: 100,
            fitnessMax,
            fitnessRecovery,
            wage,
            contract: {
                yearsRemaining: contractYears,
                expirySeason: 1 + contractYears, // Season 1 + years
            },
            attributes: {
                handling: pos === 'GK' ? skill : skill/3,
                reflexes: pos === 'GK' ? skill : skill/3,
                tackling: pos === 'DEF' ? skill : skill/2,
                marking: pos === 'DEF' ? skill : skill/2,
                heading: skill/2,
                positioning: pos !== 'FWD' ? skill/2: skill/3,
                passing: pos === 'MID' ? skill : skill/2,
                dribbling: pos === 'MID' || pos === 'FWD' ? skill : skill/3,
                creativity: pos === 'MID' ? skill : skill/3,
                finishing: pos === 'FWD' ? skill : skill/3,
                pace: skill/2,
            },
            lastSeasonChange: 0,
            history: [],
            gamesPlayed: 0,
            goalsScored: 0,
            goalsConceded: 0,
            assists: 0,
            yellowCards: 0,
            redCards: 0,
            yellowCardAccumulation: 0,
            suspension: null,
            injury: null,
            hue: Math.floor(Math.random() * 360),
            faceEmoji: (gender === 'female' ? FEMALE_PLAYER_FACES : MALE_PLAYER_FACES)[Math.floor(Math.random() * 6)],
            morale: 'Content',
            personality: personalityTypes[Math.floor(Math.random() * personalityTypes.length)],
            recentRatings: [],
            gender,
            potmAwards: 0,
            marketValue: initialValue,
            marketValueHistory: [],
            favoredFoot,
            favoredPositionCategory,
            flexibility: this.generateFlexibility(pos),
            // FIX: Add missing 'developmentHistory' property to conform to the Player type.
            developmentHistory: [],
            injuryHistory: [],
        };
    }

    static generateSquad(baseSkill: number, size: number = 22, gender: 'male' | 'female', leagueName: string, config: GameConfig): Player[] {
        const squad = [];
        const usedNames = new Set<string>();
        const firstNamesSource = gender === 'female' ? femaleFirstNames : maleFirstNames;
        
        for (let i = 0; i < size; i++) {
            let playerName: string;
            do {
                const randomFirstName = firstNamesSource[Math.floor(Math.random() * firstNamesSource.length)];
                const randomLastName = lastNames[Math.floor(Math.random() * lastNames.length)];
                playerName = `${randomFirstName} ${randomLastName}`;
            } while (usedNames.has(playerName));
            usedNames.add(playerName);
    
            let pos: 'GK'|'DEF'|'MID'|'FWD';
            if (i < 3) pos = 'GK';
            else if (i < 10) pos = 'DEF';
            else if (i < 17) pos = 'MID';
            else pos = 'FWD';
            
            let skillVariance = Math.floor(Math.random() * 12) - 6; // Range [-6, +5], a 12-point spread
            
            if (Math.random() < 0.1) { // 10% chance for a player to be a "high potential" or "star"
                skillVariance += Math.floor(Math.random() * 8); // Add up to 7 extra points
            }
    
            if (Math.random() < 0.05) { // 5% chance for a dud
                 skillVariance -= Math.floor(Math.random() * 5); // Subtract up to 4 points
            }
    
            const skill = Math.max(10, Math.min(120, Math.round(baseSkill + skillVariance)));
            squad.push(this.generatePlayer(playerName, pos, skill, gender, leagueName, config));
        }
        return squad;
    }

    static generateYouthPlayer(team: TeamInLeague, pos: Position, leagueName: string, config: GameConfig, preferences?: { roleFocus?: 'Balanced' | 'Attacking' | 'Defensive' | 'Goalkeeper'; footPreference?: 'Balanced' | 'Left-footed' | 'Right-footed'; widthFocus?: 'Balanced' | 'Central' | 'Wide'; playingStyle?: 'Balanced' | 'Technical' | 'Pace' | 'Physical'; }, effectiveness: number = 1): Player {
        const firstNamesSource = team.squad[0]?.gender === 'female' ? femaleFirstNames : maleFirstNames;
        const randomFirstName = firstNamesSource[Math.floor(Math.random() * firstNamesSource.length)];
        const randomLastName = lastNames[Math.floor(Math.random() * lastNames.length)];
        const name = `${randomFirstName} ${randomLastName}`;

        const academyLevel = team.youthAcademy.level;

        // Wonderkid chance calculation
        // League ranking: 0 = top league, higher numbers = lower leagues
        const leagueRank = config.LEAGUE_NAMES.indexOf(leagueName);
        const isBottomLeague = leagueRank >= config.LEAGUE_NAMES.length - 2;

        // Bottom league: consistent 2% to generate ~2 wonderkids per season (helps them progress)
        // Other leagues: scales with academy level (0.5% -> 3% based on level 1->6)
        let wonderkidChance: number;
        if (isBottomLeague) {
            wonderkidChance = 0.02; // 2% - yields ~2 wonderkids/season with ~8 players/intake × 13 intakes
        } else {
            // Scale by academy level: level 1 = 0.5%, increases to 3% at level 6
            // Formula: 0.5% + (level - 1) * 0.5%
            wonderkidChance = 0.005 + (academyLevel - 1) * 0.005;
        }

        const isWonderkid = Math.random() < wonderkidChance;
        
        let baseSkill: number;
        let potential: number;

        if (isWonderkid) {
            baseSkill = 40 + (Math.random() * 15) + (academyLevel * 2);
            potential = 90 + Math.floor(Math.random() * 10);
        } else {
            baseSkill = 25;
            potential = baseSkill + 10 + (academyLevel * 5) + (Math.random() * 15);
        }
        
        const skill = Math.round(
            baseSkill + (Math.random() * 15) + (academyLevel * 2.5)
        );
        const finalSkill = Math.max(15, Math.min(65, skill));
        const finalPotential = Math.max(finalSkill + 8, Math.min(120, potential));

        const fitnessMax = 85 + Math.floor(Math.random() * 16); // 85-100, youth have good recovery potential
        const fitnessRecovery = 10 + Math.floor(Math.random() * 6); // 10-15

        // FIX: Add favoredFoot and favoredPositionCategory properties
        // Apply foot preference with effectiveness modifier
        const footPref = preferences?.footPreference || 'Balanced';
        const randFoot = Math.random();
        let favoredFoot: 'Left' | 'Right' | 'Either';

        if (footPref === 'Left-footed') {
            // Base: Right 65%, Left 25%, Either 10%
            // Target: Right 25%, Left 65%, Either 10%
            // Applied = Base + (Target - Base) * effectiveness
            const rightChance = 0.65 + (0.25 - 0.65) * effectiveness; // 65% -> 25% with effectiveness
            const leftChance = 0.25 + (0.65 - 0.25) * effectiveness; // 25% -> 65% with effectiveness
            if (randFoot < rightChance) favoredFoot = 'Right';
            else if (randFoot < rightChance + leftChance) favoredFoot = 'Left';
            else favoredFoot = 'Either';
        } else if (footPref === 'Right-footed') {
            // Boost right-footed slightly
            const rightChance = 0.65 + (0.75 - 0.65) * effectiveness; // 65% -> 75% with effectiveness
            const leftChance = 0.25 - (0.25 - 0.15) * effectiveness; // 25% -> 15% with effectiveness
            if (randFoot < rightChance) favoredFoot = 'Right';
            else if (randFoot < rightChance + leftChance) favoredFoot = 'Left';
            else favoredFoot = 'Either';
        } else {
            // Balanced - original logic
            if (randFoot < 0.65) favoredFoot = 'Right';
            else if (randFoot < 0.9) favoredFoot = 'Left';
            else favoredFoot = 'Either';
        }

        // Apply width focus preference with effectiveness modifier
        const widthPref = preferences?.widthFocus || 'Balanced';
        let favoredPositionCategory: 'Central' | 'Wide' | 'Any';
        switch (pos) {
            case 'GK':
                favoredPositionCategory = 'Central';
                break;
            case 'DEF':
                if (widthPref === 'Central') {
                    const centralChance = 0.5 + (0.7 - 0.5) * effectiveness; // 50% -> 70% with effectiveness
                    favoredPositionCategory = Math.random() < centralChance ? 'Central' : 'Wide';
                } else if (widthPref === 'Wide') {
                    const wideChance = 0.5 + (0.7 - 0.5) * effectiveness; // 50% -> 70% with effectiveness
                    favoredPositionCategory = Math.random() < (1 - wideChance) ? 'Central' : 'Wide';
                } else {
                    favoredPositionCategory = Math.random() < 0.5 ? 'Central' : 'Wide';
                }
                break;
            case 'MID':
                if (widthPref === 'Central') {
                    const centralChance = 0.5 + (0.7 - 0.5) * effectiveness;
                    favoredPositionCategory = Math.random() < centralChance ? 'Central' : 'Wide';
                } else if (widthPref === 'Wide') {
                    const wideChance = 0.5 + (0.7 - 0.5) * effectiveness;
                    favoredPositionCategory = Math.random() < (1 - wideChance) ? 'Central' : 'Wide';
                } else {
                    favoredPositionCategory = Math.random() < 0.5 ? 'Central' : 'Wide';
                }
                break;
            case 'FWD':
                if (widthPref === 'Central') {
                    const centralChance = 0.6 + (0.75 - 0.6) * effectiveness;
                    favoredPositionCategory = Math.random() < centralChance ? 'Central' : 'Wide';
                } else if (widthPref === 'Wide') {
                    const wideChance = 0.4 + (0.6 - 0.4) * effectiveness;
                    favoredPositionCategory = Math.random() < (1 - wideChance) ? 'Central' : 'Wide';
                } else {
                    favoredPositionCategory = Math.random() < 0.6 ? 'Central' : 'Wide';
                }
                break;
            default:
                favoredPositionCategory = 'Any';
        }

        // Build attributes with playing style preference
        const playingStyle = preferences?.playingStyle || 'Balanced';

        const getTechnicalBoost = (base: number, attr: string): number => {
            if (playingStyle === 'Technical' && ['passing', 'creativity', 'dribbling'].includes(attr)) {
                return base * (1 + (0.05 * effectiveness));
            }
            return base;
        };
        const getPaceBoost = (base: number): number => {
            if (playingStyle === 'Pace') return base * (1 + (0.05 * effectiveness));
            if (playingStyle === 'Technical') return base * (1 - (0.02 * effectiveness));
            return base;
        };
        const getPhysicalBoost = (base: number, attr: string): number => {
            if (playingStyle === 'Physical' && ['tackling', 'marking', 'heading'].includes(attr)) {
                return base * (1 + (0.05 * effectiveness));
            }
            if (playingStyle === 'Pace' && ['tackling', 'marking', 'heading'].includes(attr)) {
                return base * (1 - (0.02 * effectiveness));
            }
            return base;
        };

        const newPlayer: Player = {
            id: youthPlayerIdCounter--,
            name,
            age: 16 + Math.floor(Math.random() * 3), // Youth players are 16-18
            position: pos,
            skill: finalSkill,
            potential: finalPotential,
            form: 0,
            fitness: 100,
            fitnessMax,
            fitnessRecovery,
            attributes: {
                handling: pos === 'GK' ? finalSkill : getTechnicalBoost(finalSkill / 3, 'handling'),
                reflexes: pos === 'GK' ? finalSkill : getTechnicalBoost(finalSkill / 3, 'reflexes'),
                tackling: getPhysicalBoost(pos === 'DEF' ? finalSkill : finalSkill / 2, 'tackling'),
                marking: getPhysicalBoost(pos === 'DEF' ? finalSkill : finalSkill / 2, 'marking'),
                heading: getPhysicalBoost(finalSkill / 2, 'heading'),
                positioning: getPaceBoost(pos !== 'FWD' ? finalSkill / 2 : finalSkill / 3),
                passing: getTechnicalBoost(pos === 'MID' ? finalSkill : finalSkill / 2, 'passing'),
                dribbling: getTechnicalBoost(pos === 'MID' || pos === 'FWD' ? finalSkill : finalSkill / 3, 'dribbling'),
                creativity: getTechnicalBoost(pos === 'MID' ? finalSkill : finalSkill / 3, 'creativity'),
                finishing: getPaceBoost(pos === 'FWD' ? finalSkill : finalSkill / 3),
                pace: getPaceBoost(finalSkill / 2),
            },
            injury: null,
            lastSeasonChange: 0,
            gamesPlayed: 0,
            goalsScored: 0,
            goalsConceded: 0,
            assists: 0,
            yellowCards: 0,
            redCards: 0,
            yellowCardAccumulation: 0,
            suspension: null,
            history: [],
            hue: Math.floor(Math.random() * 360),
            faceEmoji: (team.squad[0]?.gender === 'female' ? FEMALE_PLAYER_FACES : MALE_PLAYER_FACES)[Math.floor(Math.random() * 6)],
            isPromotedYouth: false,
            wage: 0, // No wage until promoted
            contract: {
                yearsRemaining: 0, // No contract until promoted
                expirySeason: 0,
            },
            morale: 'Content',
            personality: ['Ambitious', 'Loyal', 'Professional', 'Hot-headed'][Math.floor(Math.random() * 4)] as any,
            gender: team.squad[0]?.gender || 'male',
            recentRatings: [],
            potmAwards: 0,
            marketValue: 0,
            marketValueHistory: [],
            favoredFoot,
            favoredPositionCategory,
            flexibility: this.generateFlexibility(pos),
            // FIX: Add missing 'developmentHistory' property to conform to the Player type.
            developmentHistory: [],
            injuryHistory: [],
        };

        const gameType = newPlayer.gender === 'female' ? 'womens' : 'mens';
        // Set wage based on their potential skill for when they get promoted
        newPlayer.wage = getPlayerWeeklyWage(newPlayer, leagueName, gameType, config);
        newPlayer.marketValue = getPlayerValue(newPlayer, leagueName, gameType, config);
        
        return newPlayer;
    }
}